module.exports = __webpack_public_path__ + "src/assets/img/light_front.17008188.svg";